import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var NewFolderSvg = function NewFolderSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.902 21H2V3h6.601l3.744 3.544H22V21zM3.477 19.601h16.946V7.943h-8.769L7.911 4.399H3.478z"
  }));
};
export var NewFolder = function NewFolder(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: NewFolderSvg
  }));
};